import PropTypes from "prop-types";
import { createContext, useContext, useState } from "react";
import api from "../common/api/api";
import { toast } from "react-toastify";


export const AdvisorContext = createContext();

export const AdvisorProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [advisorData, setAdvisorData] = useState([]);
    const [advisorProofData, setAdvisorProofData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [advisor, setAdvisor] = useState([]);


    const getAdvisorList = async (request) => {
        setLoading(true);
        try {
            const response = await api.advisor.getAlladvisorsList(request);
            if (response?.success) {
                setAdvisorData(response.data.docs);
                setTotalPages(response?.data.totalDocs);
            }
        } catch (error) {
            toast.error(error?.message || "Something went wrong!");
        } finally {
            setLoading(false);
        }
    };

    const getAdvisorListById = async (id) => {
        setLoading(true);
        try {
            const response = await api.advisor.getAdvisorDetailsById(id);
            if (response?.success) {
                setLoading(false);
                setAdvisor(response.data);
            }
        } catch (error) {
            setLoading(false);
            toast.error(error?.message || "Something went wrong!");
        } finally {
            setLoading(false);
        }
    }


    const getAdvisorProof = async (request) => {
        setLoading(true);
        try {
            const response = await api.advisor.getAdvisoProofById(request);
            if (response?.success) {
                console.log('response', response?.data)
                setAdvisorProofData(response?.data);
            }
        } catch (error) {
            toast.error(error?.message || "Something went wrong!");
        } finally {
            setLoading(false);
        }
    };


    const advisorUserChangeStatus = async (request) => {
        setLoading(true)
        try {
            const response = await api.advisor.advisorUserChangeStatus(request);
            if (response?.success) {
                toast.success(response?.message);
                getAdvisorList();
            }
        } catch (error) {
            toast.error(error?.message || "Something went wrong!");
        }
        finally {
            setLoading(false);
        }
    }



    const contextValue = {
        loading,
        getAdvisorList,
        advisorData,
        getAdvisorListById,
        advisor, totalPages,
        getAdvisorProof,
        advisorProofData,
        advisorUserChangeStatus
    };

    return (
        <AdvisorContext.Provider value={contextValue}>{children}</AdvisorContext.Provider>
    );
};

AdvisorProvider.propTypes = {
    children: PropTypes.node,
};

export const useAdvisor = () => useContext(AdvisorContext);
